import { getLocale } from 'i18n/locale';
import { ETemplateIdRemap } from '../../public/prompts/template-id-remap';

/**
 * Utility to get AI prompts based on templateId and current locale.
 * Maps 'templateId' from the code to target IDs from the JSON using ETemplateIdRemap.
 *
 * @param templateId - The Template ID from the code (e.g. '2.2.1') or a specific mapping key ('2.1.5-region-openings')
 * @param options - Optional names for resort and region to replace placeholders
 * @returns Array of prompt strings or null if not found
 */
export const getPromptsByTemplateId = (
  templateId: string,
  name?: string,
): string[] | null => {
  const locale = getLocale();
  const targetId = ETemplateIdRemap[templateId as keyof typeof ETemplateIdRemap];

  if (!targetId) {
    return null;
  }

  try {
    // eslint-disable-next-line import/no-dynamic-require, global-require
    const promptsData = require(`../../public/prompts/ai-prompts-${locale}.json`);
    const prompts = promptsData[targetId] as string[] | undefined;

    if (!prompts) {
      return null;
    }

    return prompts.map((prompt) => prompt
      .replace(/<resort>/gi, name || '')
      .replace(/<region>/gi, name || ''));
  } catch (error) {
    return null;
  }
};
